  (function() {
    function initGlobalScrollAnimations() {
      // Check if GSAP and ScrollTrigger are loaded
      if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        setTimeout(initGlobalScrollAnimations, 50);
        return;
      }

      gsap.registerPlugin(ScrollTrigger);

      // Find all elements marked for scroll animation
      const animElements = document.querySelectorAll('[data-animate="scroll-up"]');

      animElements.forEach((el) => {
        // Prevent re-triggering if already initialized
        if (el.dataset.animated === "true") return;

        gsap.fromTo(
          el,
          {
            opacity: 0,
            y: 35
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: "power2.out",
            scrollTrigger: {
              trigger: el,
              start: "top 85%", // Viewport ke bottom 15% me aate hi trigger hoga
              toggleActions: "play none none none",
              once: true
            },
            onComplete: () => {
              el.dataset.animated = "true";
            }
          }
        );
      });
    }
    function initGlobalGridAnimations() {
      if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        setTimeout(initGlobalGridAnimations, 50);
        return;
      }

      gsap.registerPlugin(ScrollTrigger);

      // Find all grid/card containers
      const grids = document.querySelectorAll('[data-animate-grid]');

      grids.forEach((grid) => {
        if (grid.dataset.animated === "true") return;

        // Select all cards inside this specific grid
        const cards = grid.querySelectorAll('[data-animate-item]');
        if (cards.length === 0) return;

        cards.forEach((card, index) => {
          const image = card.querySelector('[data-animate-image]') || card.querySelector('img');

          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: card,
              start: "top 90%",
              toggleActions: "play none none none",
              once: true
            }
          });

          // 1. Card Container Animation
          tl.fromTo(
            card,
            { opacity: 0, y: 30 },
            {
              opacity: 1,
              y: 0,
              duration: 0.45,
              ease: "power2.out",
              delay: (index % 4) * 0.08 // Row-wise fast stagger delay
            }
          );

          // 2. Card Image Animation (if present)
          if (image) {
            tl.fromTo(
              image,
              { opacity: 0, scale: 1.08 },
              {
                opacity: 1,
                scale: 1,
                duration: 0.5,
                ease: "power2.out"
              },
              "-=0.35"
            );
          }
        });

        grid.dataset.animated = "true";
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initGlobalGridAnimations);
    } else {
      initGlobalGridAnimations();
    }

    // Shopify customizer section reload support
    document.addEventListener('shopify:section:load', initGlobalGridAnimations);

    // Run on Initial Page Load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initGlobalScrollAnimations);
    } else {
      initGlobalScrollAnimations();
    }

    // Support for Shopify Theme Editor (Dynamic Section Loading)
    document.addEventListener('shopify:section:load', initGlobalScrollAnimations);
  })();
  (function() {
    // 1. iOS 13+ iPad detection (Mac touch devices)
    const isIPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    
    // 2. Legacy iPad detection (Older iOS versions)
    const isLegacyIPad = /iPad/.test(navigator.userAgent);

    // Agar iPad hai, toh <html> tag par class add karein
    if (isIPadOS || isLegacyIPad) {
      document.documentElement.classList.add('is-ipad');
    }
  })();